import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import logo1 from "../Components/images/logo1.jpeg";
import logo2 from "../Components/images/logo2.avif";
import logo3 from "../Components/images/logo3.avif";
import logo4 from "../Components/images/logo4.avif";
import logo5 from "../Components/images/logo5.avif";
import logo6 from "../Components/images/logo6.avif";
import logo7 from "../Components/images/logo7.avif";
import logo8 from "../Components/images/logo8.avif";
import logo9 from "../Components/images/logo9.avif";
import logo10 from "../Components/images/logo10.avif";
import logo11 from "../Components/images/logo1.webp";
import logo12 from "../Components/images/logo12.png";
import logo13 from "../Components/images/logo13.png";
import abt1 from "../Components/images/abt4.jpeg";
import abt2 from "../Components/images/abt2.jpeg";

import AchievementSection from "../Components/AchievementSection";

export default function About() {
  return (
    <div className="bg-black text-white min-vh-100 py-5">
      <Container>
        {/* Hero Section */}
        <div className="text-center home  " style={{ marginTop: "90px" }}>
          <h2
            className="display-3 fw-bold anton ft2 mt-4"
            style={{ maxWidth: "1000px" }}
          >
            Built for Performance. 
            <br />
            <span className="text-warning2"> Driven by Growth.</span>
          </h2>

          <p className="mt-3 text-secondary fs-5" style={{ maxWidth: "900px" }}>
            At our core, we’re all about delivering results — but we never
            sacrifice personality. We bring our unique energy to every project,
            ensuring that every solution is not only impactful but also creative
            and aligned with who we are.
          </p>
        </div>

        {/* Partners Section */}
        <div className="text-center mt-5 pt-3">
          <div className="logo-slider">
            <div className="slider-track">
              <img src={logo11} alt="Shopify" />
              <img src={logo2} alt="Ecomflows" />
              <img src={logo3} alt="Partner 1" />
              <img src={logo4} alt="Service Points" />
              <img src={logo5} alt="Elysian Exit" />

              <img src={logo6} alt="Shopify" />
              <img src={logo7} alt="Ecomflows" />
              <img src={logo8} alt="Partner 1" />
              <img src={logo9} alt="Service Points" />
              <img src={logo10} alt="Elysian Exit" />

              <img src={logo12} alt="Elysian Exit" />
              <img src={logo13} alt="Elysian Exit" />
              <img src={logo11} alt="Shopify" />
              <img src={logo2} alt="Ecomflows" />
              <img src={logo3} alt="Partner 1" />
              <img src={logo4} alt="Service Points" />
              <img src={logo5} alt="Elysian Exit" />

              <img src={logo6} alt="Shopify" />
              <img src={logo7} alt="Ecomflows" />
              <img src={logo8} alt="Partner 1" />
              <img src={logo9} alt="Service Points" />
              <img src={logo10} alt="Elysian Exit" />

              <img src={logo12} alt="Elysian Exit" />
              <img src={logo13} alt="Elysian Exit" />
              <img src={logo11} alt="Shopify" />
              <img src={logo2} alt="Ecomflows" />
              <img src={logo3} alt="Partner 1" />
              <img src={logo4} alt="Service Points" />
              <img src={logo5} alt="Elysian Exit" />

              <img src={logo6} alt="Shopify" />
              <img src={logo7} alt="Ecomflows" />
              <img src={logo8} alt="Partner 1" />
              <img src={logo9} alt="Service Points" />
              <img src={logo10} alt="Elysian Exit" />

              <img src={logo12} alt="Elysian Exit" />
              <img src={logo13} alt="Elysian Exit" />
              <img src={logo11} alt="Shopify" />
              <img src={logo2} alt="Ecomflows" />
              <img src={logo3} alt="Partner 1" />
              <img src={logo4} alt="Service Points" />
              <img src={logo5} alt="Elysian Exit" />

              <img src={logo6} alt="Shopify" />
              <img src={logo7} alt="Ecomflows" />
              <img src={logo8} alt="Partner 1" />
              <img src={logo9} alt="Service Points" />
              <img src={logo10} alt="Elysian Exit" />

              <img src={logo12} alt="Elysian Exit" />
              <img src={logo13} alt="Elysian Exit" />
            </div>
          </div>
        </div>

        {/* About Info Section */}
        <section className="py-1">

<div className="row">
  <div className="col-md-6 d-flex align-items-baseline" >
      <img
                src={abt1}
                alt="Team having fun"
                className="img-fluid rounded shadow-sm"
                style={{ borderRadius: "12px" }}
              />
    </div>

  <div className="col-md-6">
     <div className=" about-container align-items-center ">
            <h2 className="fw-bold display-5 ftfl0">
              On a
              <span className="text-warning"> PROFESSIONAL</span> note
            </h2>

            <h4 className="fw-bold mt-4 ftfl0" style={{ letterSpacing: "1px" }}>
              We're certified experts in what we do
            </h4>
            <p className="text-secondary">
              With years of hands-on experience, our team at Dropshopi is made up of certified professionals in digital marketing and web design. We stay up-to-date on the latest trends and best practices to ensure our clients get the most cutting-edge solutions.
            </p>

            <h4 className="fw-bold mt-4 ftfl0" style={{ letterSpacing: "1px" }}>
              Quality is our priority
            </h4>
            <p className="text-secondary">
              We pride ourselves on delivering nothing short of excellence. Every project we take on is handled with meticulous attention to detail to ensure it not only looks great but performs exceptionally.
            </p>

            <h4 className="fw-bold mt-4 ftfl0" style={{ letterSpacing: "1px" }}>
             We're results-driven
            </h4>
            <p className="text-secondary">
             At Dropshopi, everything we do is focused on one thing—delivering data-driven results. We integrate our custom strategy designed to help our clients grow their business and maximise their results.
            </p>

            {/* <h4 className="fw-bold mt-4 ftfl0" style={{ letterSpacing: "1px" }}>
              Client-Centered Collaboration
            </h4>
            <p className="text-secondary">
              We don’t just work for you — we work with you. Transparency,
              communication, and alignment are central to how we operate. You’ll
              always know where we’re headed and why.
            </p> */}

            {/* <h4 className="fw-bold mt-4 ftfl0" style={{ letterSpacing: "1px" }}>
              Full-Funnel Expertise
            </h4>
            <p className="text-secondary">
              From top-of-funnel traffic to conversion optimization, we bring a
              deep understanding of every stage of the customer journey —
              ensuring nothing falls through the cracks.
            </p> */}

            {/* <h4 className="fw-bold mt-4 ftfl0" style={{ letterSpacing: "1px" }}>
              Scalable Solutions for Every Stage
            </h4>
            <p className="text-secondary">
              Whether you're launching, growing, or scaling, our strategies
              evolve with you. We build systems that grow as your business does
              — no cookie-cutter templates here.
            </p> */}
          </div>
  </div>
</div>

         
        </section>

        {/* Achievement section */}

        <AchievementSection />











 <section className="py-1">

<div className="container">
  <div className="row">

    <div className="col-md-6 d-flex align-items-center d-md-none">
  <img
    src={abt2}
    alt="Team having fun"
    className="img-fluid rounded shadow-sm"
    style={{ borderRadius: "12px" }}
  />
</div>



    <div className="col-md-6">
      <div className=" about-container align-items-center ">
            <h2
                className="display-3   ft3 mt-4 ftfl0"
                style={{ maxWidth: "1000px", letterSpacing: "0px" }}
              >
                On a<span className="text-warning"> PERSONAL</span> note
              </h2>

            <h4 className="fw-bold mt-4 ftfl0" style={{ letterSpacing: "1px" }}>
              We're always laughing
            </h4>
            <p className="text-secondary">
              Our office is filled with laughter—whether we're cracking jokes during a brainstorming session or sharing funny stories from our weekends. We believe that having fun is key to staying creative and energized.
            </p>

            <h4 className="fw-bold mt-4 ftfl0" style={{ letterSpacing: "1px" }}>
              We're a supportive bunch
            </h4>
            <p className="text-secondary">
              We're more than just colleagues—we're a team that looks out for one another. Whether someone needs help on a project or just a pep talk, we've got each other's backs.
            </p>

            <h4 className="fw-bold mt-4 ftfl0" style={{ letterSpacing: "1px" }}>
              We embrace quirkiness
            </h4>
            <p className="text-secondary">
             We love that each team member brings something unique to the table, whether it’s a quirky hobby or an unusual talent. It’s what makes our team dynamic and keeps things interesting!
            </p>

            
             
          </div>
    </div>
    <div className="col-md-6 d-none d-md-flex align-items-center">
  <img
    src={abt2}
    alt="Team having fun"
    className="img-fluid rounded shadow-sm"
    style={{ borderRadius: "12px" }}
  />
</div>

  </div>
</div>

          
        </section>










 







        {/* stategy */}

        <div className="bg-black text-white py-4">
          <Container className="d-flex justify-content-center align-items-center ">
            <div className="box-container">
              <div className="strategy-card text-center px-4 py-5">
                <h1 className="display-3 fw-bold anton ft1 ">
                  Ready to Experience Game-Changing Growth?
                  <br />
                  Put Our{" "}
                  <span className="text-warning2">NEXT LEVEL STRATEGY </span>to
                  the Test
                </h1>

                <p className="text-secondary mt-4 fs-5 fw-medium">
                  <span className="text-warning">
                    <span>&#9889;</span> Limited Spots Available -{" "}
                  </span>{" "}
                  We only work with entrepreneurs who
                  <br /> are ready to <strong>scale and maximise ROAS</strong>.
                  Don’t miss this
                  <br /> opportunity – book your session today!
                </p>

                <Link to="/contact" variant="primary" className="btn-purple  ">
                  Book Your Free Strategic Call
                </Link>
              </div>
            </div>
          </Container>
        </div>
      </Container>
    </div>
  );
}
